import { render } from "./ClientRiskProfile.vue?vue&type=template&id=34ef6185&scoped=true"
import script from "./ClientRiskProfile.vue?vue&type=script&lang=js"
export * from "./ClientRiskProfile.vue?vue&type=script&lang=js"

import "./ClientRiskProfile.vue?vue&type=style&index=0&id=34ef6185&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ef6185"]])

export default __exports__